import { createContext } from "react";
import { CRMUnreadCounts } from "@jugl-web/rest-api/integrations/types";

export interface CRMUnreadIndicatorsContextValue {
  unreadCounts: CRMUnreadCounts | null;
  totalUnreadCount: number;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const CRMUnreadIndicatorsContext =
  createContext<CRMUnreadIndicatorsContextValue | null>(null);
